import { useDispatch, useSelector } from 'react-redux';
import {
  deleteInvitationSource,
  isDeleteInvitationSourcePanelOpenSelector,
  isDeletingInvitationSourceSelector,
  setIsDeleteInvitationSourcePanelOpen,
} from '../../../../../../../../features/pageFeatures/createHearingPageSlice';
import { noSelectionKey } from '../../../../../../../../utilities/filterAndSortingsUtil';

export const useDeleteInvitationSource = (
  hearingId,
  selectedGroupName,
  setSelectedGroupName,
) => {
  const dispatch = useDispatch();

  const isPopupOpen = useSelector(isDeleteInvitationSourcePanelOpenSelector);
  const isUpdating = useSelector(isDeletingInvitationSourceSelector);

  function setIsPopupOpen() {
    dispatch(setIsDeleteInvitationSourcePanelOpen(false));
  }

  function onConfirm() {
    dispatch(
      deleteInvitationSource({
        hearingId,
        invitationSourceName: selectedGroupName,
      }),
    );
    setSelectedGroupName(noSelectionKey);
  }

  return {
    isPopupOpen,
    isUpdating,
    setIsPopupOpen,
    onConfirm,
  };
};
